import { inject, Injectable } from '@angular/core';

import {
    ApAnalyticsService,
    ApPageviewDataService,
    ClickAnalyticsData,
    FormFieldValue,
    FormStepAnalyticsData,
    PageviewAnalyticsData
} from '@ap/analytics';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    private readonly analyticsService: ApAnalyticsService = inject(ApAnalyticsService);
    private readonly pageViewDataService: ApPageviewDataService = inject(ApPageviewDataService);

    public pushAnalyticsPageview(subPage: string, isBusiness: boolean): void {
        const pageviewData: PageviewAnalyticsData = this.pageViewDataService.getPageviewData(
            'analytics.page.type',
            'analytics.product.name',
            'analytics.product.category',
            isBusiness ? 'Zakelijk' : 'Particulier',
            'analytics.page.site.section',
            'analytics.platform.name'
        );
        if (subPage) {
            pageviewData.pageName = `${pageviewData.pageName}:${subPage}`;
        }

        this.analyticsService.push(pageviewData);
    }

    public pushAnalyticsClickEvent(clickedElement: string, clickAction: string): void {
        const clickAnalyticsData = new ClickAnalyticsData(clickedElement, clickAction);

        this.analyticsService.push(clickAnalyticsData);
    }

    public pushAnalyticsFormStep(stepName: string, stepNumber: number, status: string, fieldValues: FormFieldValue[] = []): void {
        const formStepAnalyticsData = new FormStepAnalyticsData('analytics.title', 'Angular', stepName, stepNumber, status, fieldValues);

        this.analyticsService.push(formStepAnalyticsData);
    }
}
